// extracted by mini-css-extract-plugin
export default {"cta-section":"style_cta-section__5gpYO","cta-wrapper":"style_cta-wrapper__5+31P","cta-subtitle":"style_cta-subtitle__LA579"};